// Package imports
import React, { useState, useEffect } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { capitalize, filter, size } from "lodash";
import { unicodeToString } from "../../Js/Common";
import { isEmpty, xor, map } from "lodash";
import RecAsset from "./UserAnswer/RecAsset";
import StatusIndicator from "../../Components/Card/AssetUI/StatusIndicator";
import Chip from "@mui/material/Chip";
import { makeStyles } from "@material-ui/core/styles";
import WordAsset from "./UserAnswer/WordAsset";
import RecadvAsset from "./UserAnswer/RecadvAsset";
import TeacherComment from "./TeacherComment";

// Global variables

// Component
const UserAnswers = (props) => {
  // State
  const styles = useStyles();
  const { attempedAnsLog } = useSelector((state) => state.currentAsset);
  const [isPlaying, setIsPlaying] = useState(false);

  const renderTemplate = (data, userAns) => {
    console.log("attempedAnsLog", attempedAnsLog);
    console.log("data====", data);
    console.log("userAns====", userAns);
    let correctAns = attempedAnsLog.outcome.actualAnswer;
    switch (data.info.asset_type_alias) {
      case "MC":
      case "TF":
      case "FIB":
      case "JW":
      case "THESAURUS":
      case "TFS":
      case "IE":
        return (
          <WwTemplate1
            userAns={userAns}
            arrayAsSentence={false}
            correctAnswer={correctAns}
            assetType={data.info.asset_type_alias}
          ></WwTemplate1>
        );
        break;
      case "SF":
        return (
          <WwTemplate1
            userAns={userAns}
            arrayAsSentence={true}
            correctAnswer={correctAns}
            assetType={data.info.asset_type_alias}
          ></WwTemplate1>
        );
        break;
      case "RTS":
        return (
          <WwTemplate1
            userAns={userAns}
            arrayAsSentence={true}
            isUnicode={true}
            objectKey="text"
            correctAnswer={correctAns}
            assetType={data.info.asset_type_alias}
          ></WwTemplate1>
        );
        break;
      case "MATCH":
        return (
          <WwTemplate2
            userAns={userAns}
            arrayAsSentence={false}
            answerString={data.epage.options.content.sideB}
            correctAnswer={correctAns}
          ></WwTemplate2>
        );
        break;
      case "OO":
        let ans1 = data.epage.options.content.map((val) => {
          let ans = val.text;
          return unicodeToString(ans)
            .replace(/<\/?div[^>]*>/g, "")
            .replace(/<\/?span[^>]*>/g, "")
            .replace(/<\/?br[^>]*>/g, "")
            .replace(/&nbsp;/g, " ");
        });
        console.log("ans1", ans1);
        return (
          <WwTemplate3
            userAns={userAns}
            arrayAsSentence={true}
            isUnicode={true}
            objectKey="text"
            answerString={ans1}
            correctAnswer={correctAns}
          ></WwTemplate3>
        );
        break;
      case "BINGO":
        return (
          <WwTemplate4
            userAns={userAns.ans.userans}
            objectKey="result"
          ></WwTemplate4>
        );
        break;
      case "WS":
        return (
          <WwTemplate4 userAns={userAns.ans} objectKey="score"></WwTemplate4>
        );
        break;
      case "SB":
        let ans2 = data.epage.options.content;
        return (
          <WwTemplate5 userAns={userAns} answerString={ans2}></WwTemplate5>
        );
        break;
      case "WORDGROUP":
        let ans3 = data.epage.options.content;
        return (
          <WwTemplate6 userAns={userAns} answerString={ans3}></WwTemplate6>
        );
        break;
      case "REC":
        return (
          <RecAsset userAns={userAns} asset={data.epage.options}></RecAsset>
        );
        break;
      case "DIC":
        console.log("userAns", userAns);
        let ans4 = attempedAnsLog.outcome.actualAnswer;
        let isEval = attempedAnsLog.outcome.isEvaluated;

        return (
          <WwTemplate7
            userAns={userAns}
            actualAnswer={ans4}
            isEvaluated={isEval}
          ></WwTemplate7>
        );
        break;
      case "NB":
        console.log("userAns", userAns);
        let ans5 = attempedAnsLog.outcome.actualAnswer;
        let isEval1 = attempedAnsLog.outcome.isEvaluated;

        return (
          <>
            <WwTemplate8
              userAns={userAns}
              actualAnswer={ans5}
              isEvaluated={isEval1}
            ></WwTemplate8>
            {attempedAnsLog &&
              attempedAnsLog.outcome &&
              attempedAnsLog.outcome.isEvaluated == "complete" && (
                <TeacherComment attempedAnsLog={attempedAnsLog.outcome} />
              )}
          </>
        );
        break;
      case "WORD":
        console.log("userAns", userAns);
        return <WordAsset userAns={userAns}></WordAsset>;
        break;
      case "RECADV":
        console.log("userAns", userAns);
        return <RecadvAsset userAns={userAns} asset={data.epage.options}></RecadvAsset>;
        break;
      default:
        return <span>Comming Soon...</span>;
        break;
    }
  };

  // JSX template
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sx={{
          border: 1,
          borderColor: "#EAECEE",
          borderRadius: 3,
          py: 2,
          mx: 6,
          mt: 1,
          px: 2,
        }}
      >
        {attempedAnsLog &&
          attempedAnsLog.outcome.userAnswer.map((userAns, index) => {
            return (
              <>
                <Typography variant="h6" color={"primary"}>
                  Attempt {index + 1} :
                </Typography>
                {props.content && <>{renderTemplate(props.content, userAns)}</>}
              </>
            );
          })}
      </Grid>
      {/* {props.content &&
        props.content.info.asset_type_alias == "FIB" &&
        props.content.info.asset_subtype ==
          "d16b4024-7755-4dfc-950b-f7c4171ad576" && (
          <FIBTYPO content={props.content} />
        )} */}
    </Grid>
  );
};

const WwTemplate1 = (props) => {
  return (
    <>
      {props.userAns &&
        props.userAns.ans &&
        props.userAns.ans.map((ans, index1) => {
          if (Array.isArray(ans)) {
            return (
              <Box
                sx={{
                  px: 3,
                  color: ans && filter(ans, size).length > 0 ? "black" : "#aaa",
                }}
              >
                Option {index1 + 1} :{" "}
                {ans && filter(ans, size).length > 0 ? (
                  props.arrayAsSentence ? (
                    <span>
                      {ans.join(" ")}
                      <StatusIndicator
                        correct={
                          props.correctAnswer
                            .map((val) => {
                              return unicodeToString(val)
                                .match(/[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g)
                                .join(" ");
                            })
                            .indexOf(ans.join(" ")) > -1
                            ? true
                            : false
                        }
                      ></StatusIndicator>
                    </span>
                  ) : (
                    <span>
                      {ans.length > 1 ? (
                        ans.map((ans1, index2) => {
                          return ans1 != null &&
                            ans1 != "" &&
                            ans1 != undefined ? (
                            <span>
                              {ans1}
                              {typeof ans1 == "string" ? (
                                <StatusIndicator
                                  correct={
                                    props.correctAnswer[index1].filter((o) => {
                                      return o.indexOf(ans1) > -1;
                                    }).length > 0
                                      ? true
                                      : false
                                  }
                                ></StatusIndicator>
                              ) : (
                                <StatusIndicator
                                  correct={
                                    props.correctAnswer[index1].filter((o) => {
                                      return (
                                        o.indexOf(
                                          ans1
                                            .filter((o) => {
                                              return o.length > 0;
                                            })
                                            .join(" | ")
                                        ) > -1
                                      );
                                    }).length > 0
                                      ? true
                                      : false
                                  }
                                ></StatusIndicator>
                              )}
                            </span>
                          ) : (
                            <span>
                              Not Attempted{" "}
                              <StatusIndicator
                                correct={false}
                              ></StatusIndicator>
                            </span>
                          );
                        })
                      ) : (
                        <>
                          {ans != null && ans != "" && ans != undefined ? (
                            <span>
                              {ans}
                              <StatusIndicator
                                correct={
                                  props.correctAnswer[index1].filter((o) => {
                                    return (
                                      o.indexOf(
                                        ans
                                          .filter((o) => {
                                            return o.length > 0;
                                          })
                                          .join(" | ")
                                      ) > -1
                                    );
                                  }).length > 0
                                    ? true
                                    : false
                                }
                              ></StatusIndicator>
                            </span>
                          ) : (
                            <span>
                              Not Attempted{" "}
                              <StatusIndicator
                                correct={false}
                              ></StatusIndicator>
                            </span>
                          )}
                        </>
                      )}
                    </span>
                  )
                ) : (
                  <span>
                    Not Attempted{" "}
                    <StatusIndicator correct={false}></StatusIndicator>
                  </span>
                )}
              </Box>
            );
          }

          if (ans && typeof ans == "object") {
            let cAns = ans[props.objectKey]
              ? props.isUnicode
                ? unicodeToString(ans[props.objectKey])
                : ans[props.objectKey].toString()
              : "Not Attempted";
            // console.log("ccc", cAns, props.correctAnswer[index1]);
            // console.log("ppp", ans['id'], props.correctAnswer[index1].id);
            return (
              <Box sx={{ px: 3, color: ans != null ? "black" : "#aaa" }}>
                Option {index1 + 1} : {cAns}
                {props.correctAnswer &&
                  (props.arrayAsSentence ? (
                    <StatusIndicator
                      correct={
                        ans["id"] === props.correctAnswer[index1].id
                          ? true
                          : false
                      }
                    ></StatusIndicator>
                  ) : (
                    <StatusIndicator
                      correct={
                        cAns === props.isUnicode
                          ? unicodeToString(props.correctAnswer[index1].answer)
                          : props.correctAnswer[index1].answer.toString()
                          ? true
                          : false
                      }
                    ></StatusIndicator>
                  ))}
              </Box>
            );
          }

          return (
            <Box sx={{ px: 3, color: ans != null ? "black" : "#aaa" }}>
              Option {index1 + 1} :{" "}
              {ans != null
                ? props.assetType == "IE"
                  ? ans.toString()
                  : capitalize(ans.toString())
                : "Not Attempted"}
              {props.correctAnswer && (
                <StatusIndicator
                  correct={
                    (ans != null ? ans.toString() : "") ===
                    props.correctAnswer[index1].toString()
                      ? true
                      : false
                  }
                ></StatusIndicator>
              )}
            </Box>
          );
        })}
    </>
  );
};

const WwTemplate2 = (props) => {
  return (
    <>
      {props.userAns &&
        props.userAns.ans &&
        props.userAns.ans.map((ans, index1) => {
          let uAns = props.answerString[ans].text
            ? unicodeToString(props.answerString[ans].text)
            : "Not Attempted";
          console.log(
            "uAns",
            props.userAns[index1],
            props.correctAnswer[index1]
          );
          return (
            <Box sx={{ px: 3, color: "black" }}>
              Option {index1 + 1} : {uAns}
              {props.correctAnswer && (
                <StatusIndicator
                  correct={
                    props.userAns.ans[index1] == props.correctAnswer[index1]
                      ? true
                      : false
                  }
                ></StatusIndicator>
              )}
            </Box>
          );
        })}
    </>
  );
};

const WwTemplate3 = (props) => {
  return (
    <>
      {props.userAns &&
        props.userAns.ans &&
        props.userAns.ans.map((optAns, index) => {
          console.log("props.userAns", props.userAns);
          console.log("{props.correctAnswer}", props.correctAnswer);
          return (
            <>
              {typeof optAns == "object" ? (
                <Box sx={{ px: 3, color: "black" }}>
                  Option {index + 1}:{" "}
                  <span>
                    {optAns.map((optAns1, index1) => {
                      return (
                        <span>
                          {
                            props.answerString[index].match(
                              /[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g
                            )[optAns1]
                          }
                          <StatusIndicator
                            correct={
                              props.correctAnswer[index].indexOf(optAns1) > -1
                                ? true
                                : false
                            }
                          ></StatusIndicator>
                          {+index1 < +optAns.length - 1 && " | "}
                        </span>
                      );
                    })}
                  </span>
                </Box>
              ) : (
                <span>
                  {
                    props.answerString[0].match(
                      /[a-zA-Z_0-9-$-'-’-]+|[^\s\w]+/g
                    )[optAns]
                  }
                  <StatusIndicator
                    correct={
                      props.correctAnswer.indexOf(optAns) > -1 ? true : false
                    }
                  ></StatusIndicator>
                  {index < props.userAns.ans.length - 1 && " | "}
                </span>
              )}
            </>
          );
        })}
    </>
  );
};

const WwTemplate4 = (props) => {
  return (
    <>
      {props.userAns &&
        props.userAns.map((ans, index1) => {
          return (
            <Box
              sx={{
                px: 3,
                color: "primary.main",
                fontSize: "1rem",
                fontWeight: "500",
              }}
            >
              Option {index1 + 1} : {ans.word}
              {props.objectKey == "result" ? (
                <StatusIndicator
                  correct={ans[props.objectKey] == "correct" ? true : false}
                ></StatusIndicator>
              ) : (
                <StatusIndicator
                  correct={+ans[props.objectKey] > 0 ? true : false}
                ></StatusIndicator>
              )}
            </Box>
          );
        })}
    </>
  );
};

const WwTemplate5 = (props) => {
  return (
    <>
      {props.userAns &&
        props.userAns.ans &&
        props.userAns.ans.map((optAns, index) => {
          return (
            <Box sx={{ px: 3, color: "black" }}>
              <span>
                Option {index + 1}:{" "}
                <span style={{ marginLeft: "15px" }}>
                  {unicodeToString(props.answerString[index].text)
                    .split("")
                    .map((letter, index1) => {
                      return (
                        <>
                          <Typography
                            sx={{
                              lineHeight: 1,
                              color: "#DB8829",
                              boxShadow: "none",
                              fontSize: "1rem",
                              fontWeight: "500",
                              display: "inline-flex",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            {letter}
                          </Typography>
                          {index1 <
                            unicodeToString(
                              props.answerString[index].text
                            ).split("").length -
                              1 && (
                            <Typography
                              sx={{
                                lineHeight: 1,
                                width: "0.5rem",
                                boxShadow: "none",
                                fontSize: "1rem",
                                fontWeight: "900",
                                padding: "0px 7px",
                                cursor: "pointer",
                                display: "inline-flex",
                                color: "#0a6c00",
                                "@media (min-width: 1636px)": {
                                  fontSize: "1.4rem",
                                },
                              }}
                            >
                              {optAns && optAns.indexOf(index1) != -1
                                ? "|"
                                : " "}
                            </Typography>
                          )}
                        </>
                      );
                    })}

                  <StatusIndicator
                    correct={
                      isEmpty(xor(props.answerString[index].answer, optAns)) ==
                      true
                        ? true
                        : false
                    }
                  ></StatusIndicator>
                </span>
              </span>
            </Box>
          );
        })}
    </>
  );
};

const WwTemplate6 = (props) => {
  return (
    <>
      <Box sx={{ px: 3, color: "black" }}>
        <span>
          {props.answerString.map((val, index) => {
            return (
              <Box sx={{ my: 0.5 }}>
                <span>{unicodeToString(val.text)}: </span>
                {props.userAns.ans[index].map((ans2, index1) => {
                  return (
                    <Chip
                      label={ans2.item.word}
                      deleteIcon={
                        <StatusIndicator
                          correct={
                            val.words.indexOf(ans2.item.uid) > -1 ? true : false
                          }
                        ></StatusIndicator>
                      }
                      variant="outlined"
                      onDelete={() => {
                        return false;
                      }}
                      sx={{ mx: 0.5 }}
                    ></Chip>
                  );
                })}
              </Box>
            );
          })}
        </span>
      </Box>
    </>
  );
};

const WwTemplate7 = (props) => {
  return (
    <>
      <Box sx={{ px: 3, color: "black" }}>
        <span>
          {props.userAns &&
            props.userAns.ans &&
            props.userAns.ans.map((val, index) => {
              return (
                <Box>
                  <span>{val}</span>
                  {props.isEvaluated ? (
                    <StatusIndicator
                      correct={
                        val.toString() == props.actualAnswer[index].toString()
                          ? true
                          : false
                      }
                    ></StatusIndicator>
                  ) : (
                    ""
                  )}
                </Box>
              );
            })}
        </span>
      </Box>
    </>
  );
};

const WwTemplate8 = (props) => {
  return (
    <>
      <Box sx={{ px: 3, color: "black" }}>
        <span>
          {props.userAns &&
            props.userAns.ans &&
            props.userAns.ans.map((val, index) => {
              console.log("val", val);
              return (
                <Box
                  sx={{
                    color: "primary.main",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: val[0].text1,
                    }}
                  ></div>
                </Box>
              );
            })}
        </span>
      </Box>
    </>
  );
};

const WwTemplate9 = (props) => {
  return (
    <>
      {props.userAns &&
        props.userAns.map((ans, index1) => {
          return (
            <Box
              sx={{
                px: 3,
                color: "primary.main",
                fontSize: "1rem",
                fontWeight: "500",
              }}
            >
              Option {index1 + 1} : {ans.word}
              {props.objectKey == "result" ? (
                <StatusIndicator
                  correct={ans[props.objectKey] == "correct" ? true : false}
                ></StatusIndicator>
              ) : (
                <StatusIndicator
                  correct={+ans[props.objectKey] > 0 ? true : false}
                ></StatusIndicator>
              )}
            </Box>
          );
        })}
    </>
  );
};

const useStyles = makeStyles({
  RewardImg: {
    width: "1.9rem",
    "@media (min-width: 1636px)": {
      width: "2.5rem",
    },
  },
});

export default UserAnswers;
